export const middlewareTypes = {
  ERROR: 'ERROR',
  FETCH_POLICY: 'FETCH_POLICY',
  INSTRUMENTATION: 'INSTRUMENTATION',
};
